(function () {
    "use strict";

    angular.module("app").filter("codeValue", FilterFactory);

    FilterFactory.$inject = ["$rootScope"];
    function FilterFactory($rootScope) {
        return function (key, lookup) {
            if (!key && key !== 0)
                return key;

            lookup = normalizeLookup(lookup);

            if (!lookup)
                return key;
            
            if (!Array.isArray(lookup))
                return key;
            const match = lookup.find(c => c.Key == key);
            return !match ? key : match.Value;
        };

        /**
         * Adds support to the filter to be provided with the name of the property containing the codes.
         * Useful when working in an isolate scope.
         * In that case the scope does not prototypically inherit the code* properties from the $rootScope
         * @param {any} lookup A collection or string representing the collections of codes
         * @returns the parameter unless it is a string when it returns $rootScope[lookup]
         */
        function normalizeLookup(lookup) {
            if (angular.isString(lookup))
                return $rootScope[lookup];

            return lookup;
        }
    }
})();